import { useEffect, useState } from 'react';
import { Box, createStyles, Grid, makeStyles, withStyles } from "@material-ui/core";
import UtilService from "../../../../../../../helper/service";
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import { getSegmentAsClip, } from '../../../../../../../store/actions/creator/analysis';
import AnalysisScoreIcon from '../../../../../../atoms/creator/analyzeScoreIcon';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Skeleton } from '@material-ui/lab';


interface IProps {
  session: any;
  participantsStatus: any;
  immersionData: any;
  safetyData: any;
  sessionCode: string;
  isMobile: boolean;
}

const OverallPerformanceCompare = (props: IProps) => {
  const classes = useStyles();
  const { participantsStatus, session, immersionData, safetyData, isMobile } = props;
  const { sessionOverview, fullLoaded } = useSelector((state: any) => state.creatorExperienceManager);
  const { stimulus, clipLoaded, identifiers, immersion_overall, safety_overall, cliped, settings, all, excludedParticipants } = useSelector((state: any) => state.analysis);
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const { pdfLoading } = settings;

  const dispatch = useDispatch();
  const [expLength, setExpLength] = useState<any>('Processing...');
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""



  //const isGraphImmersion = graphs.length > 0 && graphs[0]?.immersion?.data.length > 0;
  const isSafety = UtilService.isShowSafety(session?.session_type, cliped ? cliped.end_clip - cliped.start_clip : session?.session_length);
  //const isGraphSaftey = graphs.length > 0 && graphs[0]?.safety?.length > 0 && (
  //  (currentSessionCode && stimulus && session?.session_type === 'ASYNC') ? session?.session_length > 120 : true);
  //const isGraphAvailable = (session?.session_type === 'ASYNC' || (session?.session_type === 'MODERATED' && session?.session_status === 'COMPLETED'))

if (pdfLoading && all && excludedParticipants) {
//
}

/*
console.log(pdfLoading);
console.log(all);
console.log(excludedParticipants);
*/

  useEffect(() => {
    if (session?.session_length) {
      setExpLength(session?.session_length)
    }
  }, [session]);

  useEffect(() => {
    if (currentSessionCode && stimulus && session?.session_type === 'ASYNC') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, stimulus.stimulus_id))
    }
    if (currentSessionCode && session?.session_type === 'MODERATED') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, currentSessionCode))
    }
  }, [currentSessionCode, clipLoaded, stimulus?.stimulus_id, session]);

  const ScoreLinearProgress = (props: any & { value: number, barColor: string, type: string }) => {

    const default1 = (props?.type === 'immersion' ? sessionOverview.norm_imm : sessionOverview.norm_ps) * 2.4;
    const default2 = (props?.type === 'immersion' ? sessionOverview.overall_immersion_index : sessionOverview.overall_safety_index) * 2.4;
    const default3 = (props?.type === 'immersion' ? sessionOverview.benchmark_immersion_average : sessionOverview.benchmark_safety_average) * 2.4;

    let norm = 0;
    let norm1 = 0;
    let norm2 = 0;
    let norm3 = 7;
    const unit1 = Math.abs(default1 - default2);

    if (unit1 < 15) {
      let balance = 1;
      if (unit1 < 3) { balance = 7 }
      else if (unit1 < 5) { balance = 6 }
      else if (unit1 < 8) { balance = 4 }
      else if (unit1 < 10) { balance = 2.6 }
      else if (unit1 <= 12) { balance = 2 }
      else balance = 1;
      norm = balance * (default2 > default1 ? -1 : 1)
    } else {
      norm = 0
    }

    if (default3 > default1 + 15 && default3 > default2 + 15) {
      norm3 = 0;
    }
    if (default3 < default1 - 15 && default3 < default2 - 15) {
      norm3 = 0;
    }
    if (default3 <= default1 && default3 <= default2) {
      if (default3 > default1 - 15 || default3 > default2 - 15) {
        const n21 = Math.abs(default2 - default1);
        if(n21 > 6) {
          norm3 = -6;
          if(default2 > default1){
            norm1 = 7;
            if(default2 > default1 + 20){
              norm2 = 0
            }
          }else {
            norm1 = 0;
            if(default1 > default2 + 20){
              norm2 = 7
            }
          }
        }else{
          norm3 = -21;
        }
      }
    }
    if (default3 >= default1 && default3 >= default2) {

      if (default3 < default1 + 15 || default3 < default2 + 15) {
        const n21 = Math.abs(default2 - default1);
        if(n21 > 6) {
          norm3 = 6;
          if(default2 > default1){
            norm2 = -7;
          }else {
            norm1 = -7;
            if(default1 - default2 < 20){
              norm2 = -7
            }
          }
        }else{
          norm3 = 18;
        }
      }
    }
    if ((default3 < default1 && default3 > default2) || default3 < default2 && default3 > default1) {
      const n31 = Math.abs(default3 - default1);
      const n32 = Math.abs(default3 - default2);
        norm3 = 0;
        norm = 0;
        if (n31 < 8) { norm1 = 12 * (default3 > default1 ? -1 : 1) }
        if (n32 < 8) { norm2 = 9 * (default3 > default2 ? -1 : 1) }
    }

    return (
      <Box width='100%' display='flex' mt={2} style={{ position: 'relative' }}>
        <CustomLinearProgress {...props} />
        {default1 > 0 && <img src={`/assets/icons/overview/briefcase.svg`} alt='bag' className={classes.bagIcon} style={{ left: default1, marginLeft: norm + norm1 }} />}
        {default1 > 0 && <div className={classes.graphBar} style={{ left: default1 }} />}
        {default2 > 0 && <img src={`/assets/icons/overview/non_user.svg`} alt='bag' className={classes.bagIcon} style={{ left: default2, marginLeft: -norm + norm2 }} />}
        {default2 > 0 && <div className={classes.graphBar} style={{ left: default2 }} />}
        {default3 > 0 && <img src={`/assets/icons/overview/benchmark_2.svg`} alt='bag' className={classes.bagIcon} style={{ left: default3, marginLeft: norm3 }} />}
        {default3 > 0 && <div className={classes.graphBar} style={{ left: default3 }} />}
      </Box>
    );
  };

  const getImmersionNormsDiff = (immersionScore: any, norms: any) => {
    const diff = Math.abs(Number(immersionScore) - Number(norms));
    const isIncrease = Number(immersionScore) >= Number(norms);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='arrow' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than the industry average of <span className={classes.normsAverageLabel}>{norms}</span> for this type of content.
        </span>
        <div className={clsx(classes.zenDescription, classes.diffDescription)}>
          We have found that a <span style={{ color: '#212D40' }}>{diff > 10 ? diff : '10'} point increase in Immersion can predict up to a {diff > 10 ? Math.floor(diff / 2) : '5'}% sales increase.</span>
        </div>
      </div>
    )
  };

  const getImmersionAverageDiff = (immersionScore: any, average: any) => {
    const diff = Math.abs(Number(immersionScore) - Number(average));
    const isIncrease = Number(immersionScore) >= Number(average);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='arrow' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than your average score of <span className={classes.normsAverageLabel}>{average}</span> for this type of content.
        </span>
        <div className={clsx(classes.zenDescription, classes.diffDescription)}>
          We have found that a <span style={{ color: '#212D40' }}>{diff > 10 ? diff : '10'} point increase in Immersion can predict up to a {diff > 10 ? Math.floor(diff / 2) : '5'}% sales increase.</span>
        </div>
      </div>
    )
  };

  const getImmersionBenchmarkDiff = (immersionScore: any, benchmarks: any) => {
    const diff = Math.abs(Number(immersionScore) - Number(benchmarks));
    const isIncrease = Number(immersionScore) >= Number(benchmarks);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='arrow' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than your benchmarks score of <span className={classes.normsAverageLabel}>{benchmarks}</span> for this type of content.
        </span>
        <div className={clsx(classes.zenDescription, classes.diffDescription)}>
          We have found that a <span style={{ color: '#212D40' }}>{diff > 10 ? diff : '10'} point increase in Immersion can predict up to a {diff > 10 ? Math.floor(diff / 2) : '5'}% sales increase.</span>
        </div>
      </div>
    )
  };

  const getImmersionScore = () => {
    if (
      session?.session_status === 'UPCOMING'
      || (session?.session_status === 'LIVE' && session?.session_type === 'MODERATED' && participantsStatus && participantsStatus['total'] === 0)
      || (session?.session_status === 'LIVE' && session?.session_type === 'ASYNC' && identifiers?.length === 0)
    ) {
      return (
        <>
          <div className={classes.titleSection} style={{ color: '#1DB859' }}>
            <img className={classes.titleIcon} src={`/assets/icons/liveanalysis/icon_immersion_green.svg`} alt='Immersion' />
            <div className={classes.numberTitle} style={{ marginTop: 0 }}>{'--'}</div>
            <div className={classes.title}>{`No Data`}</div>
          </div>
          {!isMobile && <div style={{ minHeight: 80 }} />}
        </>
      )
    } else {
      return immersionScore();
    }
  };

  const getImmersionIndustry = () => {
    if (
      session?.session_status === 'UPCOMING'
      || (session?.session_status === 'LIVE' && session?.session_type === 'MODERATED' && participantsStatus && participantsStatus['total'] === 0)
      || (session?.session_status === 'LIVE' && session?.session_type === 'ASYNC' && identifiers?.length === 0)
    ) {
      return <></>
    } else {
      return immersionIndustry();
    }
  };

  const immersionScore = () => {
    const data = cliped?.score?.immersion || (immersionData ? immersionData : immersion_overall);
    if (!data || Object.keys(data).length === 0) {
      return (
        <>
          {fullLoaded ? <div className={classes.titleSection} style={{ color: '#1DB859' }}>
            <img className={classes.titleIcon} src={`/assets/icons/liveanalysis/icon_immersion_green.svg`} alt='Immersion' />
            <div className={classes.numberTitle} style={{ marginTop: 0 }}>{'--'}</div>
            <div className={classes.title}>{`No Data`}</div>
          </div>
            : <>
              <Skeleton height={60} width={300} />
              <Skeleton height={30} width={200} />
              <Skeleton height={30} width={200} />
            </>}

          {!isMobile && (
            <div style={{ minHeight: 80 }} />
          )}
        </>
      )
    }
    let txtcolor = data ? UtilService.getIColor(data['color_indicator']) : '#1DB859';
    let index, indexValue;
    if (session?.session_status === 'LIVE' && session?.session_type === 'MODERATED') {
      if (safety_overall && safety_overall['safety_index'] <= 1) {
        index = '--';
        indexValue = 'Waiting for Experience To Finish';
        txtcolor = UtilService.getIColor('gray')
      } else {
        index = data && data['immersion_index'];
        indexValue = data && data['context_indicator'];
      }
    } else {
      index = data && data['immersion_index'];
      indexValue = data && data['context_indicator'];
    }
    return (
      <div className={classes.rowCol}>
        <div className={classes.titleSection} style={{ color: txtcolor }}>
          {data && <AnalysisScoreIcon color={index === '--' ? 'gray' : data['color_indicator']} type={'immersion'} size={0} />}
          <div className={classes.numberTitle}>{index}</div>
          <div className={classes.title}>{indexValue}</div>
        </div>
        {(index && index !== '--' && !isMobile) && <ScoreLinearProgress type={'immersion'} variant="determinate" value={Number(index)} barcolor={txtcolor} />}

        <div style={{ minHeight: 80 }}>
          {
            (index && index !== '--') && (
              <p className={classes.zenDescription}>
                {indexValue && UtilService.getImmersionBlurb(indexValue)}
              </p>
            )
          }
        </div>
      </div>
    )
  };

  const immersionIndustry = () => {
    const data = cliped?.score?.immersion || (immersionData ? immersionData : immersion_overall);
    if (!data || Object.keys(data).length === 0) return <></>

    let index;
    if (session?.session_status === 'LIVE' && session?.session_type === 'MODERATED') {
      if (safety_overall && safety_overall['safety_index'] <= 1) {
        index = '--';
      } else {
        index = data && data['immersion_index'];
      }
    } else {
      index = data && data['immersion_index'];
    }
    return (
      <div style={{ minHeight: 80 }}>
        {
          (index && index !== '--') && (
            <>
              {
                (sessionOverview.norm_imm && sessionOverview.norm_imm > 0) ?
                  <div className={classes.rowCenter}>
                    <img src={`/assets/icons/overview/briefcase.svg`} alt='bag' style={{ marginRight: 20, marginTop: 8 }} />
                    {getImmersionNormsDiff(index, sessionOverview.norm_imm)}
                  </div>
                  : <Box mt={1}>
                    {!fullLoaded && <Skeleton height={30} width={200} />}
                  </Box>
              }

              {
                (sessionOverview.overall_immersion_index !== null && sessionOverview.overall_immersion_index > 0) &&
                <div className={classes.rowCenter}>
                  <img src={`/assets/icons/overview/non_user.svg`} alt='bag' style={{ marginRight: 25, marginLeft: 5, marginTop: 8 }} />
                  {getImmersionAverageDiff(index, sessionOverview.overall_immersion_index)}
                </div>
              }

              {
                (sessionOverview.benchmark_immersion_average !== null && sessionOverview.benchmark_immersion_average > 0 &&
                  <div className={classes.rowCenter}>
                    <img src={`/assets/icons/overview/benchmark_1.svg`} alt='bag' style={{ marginRight: 25, marginLeft: 5, marginTop: 8 }} />
                    {getImmersionBenchmarkDiff(index, sessionOverview.benchmark_immersion_average)}
                  </div>)
              }
            </>
          )
        }
      </div>
    )
  };

  const getSafetyNormsDiff = (safetyScore: any, norms: any) => {
    const diff = Math.abs(Number(safetyScore) - Number(norms));
    const isIncrease = Number(safetyScore) >= Number(norms);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='Up' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than the industry average of <span className={classes.normsAverageLabel}>{norms}</span> for this type of content.
        </span>
      </div>
    )
  };

  const getSafetyAverageDiff = (safetyScore: any, average: any) => {
    const diff = Math.abs(Number(safetyScore) - Number(average));
    const isIncrease = Number(safetyScore) >= Number(average);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='Up' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than your average score of <span className={classes.normsAverageLabel}>{average}</span> for this type of content.
        </span>
      </div>
    )
  };

  const getSafetyBenchmarkDiff = (safetyScore: any, benchmarks: any) => {
    const diff = Math.abs(Number(safetyScore) - Number(benchmarks));
    const isIncrease = Number(safetyScore) >= Number(benchmarks);
    return (
      <div className={classes.scoreDiv}>
        <img className={classes.upDownArrow} src={`/assets/icons/overview/${isIncrease ? 'up' : 'down'}-arrow.svg`} alt='Up' />
        <span className={classes.upDownLabel} style={{ color: isIncrease ? '#1DB859' : '#ED564A' }}>{isIncrease ? '+' : '-'}{diff} Pts</span>
        <span className={classes.zenDescription} style={{ paddingTop: 4 }}>
          {isIncrease ? 'higher' : 'lower'} than your benchmarks score of <span className={classes.normsAverageLabel}>{benchmarks}</span> for this type of content.
        </span>
      </div>
    )
  };

  const getSafetyScore = () => {
    if (expLength !== 'Processing...') {
      const sessionLengthSecond = parseInt(cliped ? (cliped.end_clip - cliped.start_clip) : expLength);
      if (UtilService.isShowSafety(session?.session_type, sessionLengthSecond)) {
        return safetyScore();
      }
    }
  };

  const getSafetyIndustry = () => {
    if (expLength !== 'Processing...') {
      const sessionLengthSecond = parseInt(cliped ? (cliped.end_clip - cliped.start_clip) : expLength);
      if (UtilService.isShowSafety(session?.session_type, sessionLengthSecond)) {
        return safetyIndustry();
      }
    }
  };

  const safetyScore = () => {
    const data = cliped?.score?.safety || (safetyData ? safetyData : safety_overall);
    if (!data || Object.keys(data).length === 0) {
      return (
        <>
          {fullLoaded ? <></> :
            <>
              <Skeleton height={60} width={300} />
              <Skeleton height={30} width={200} />
              <Skeleton height={30} width={200} />
            </>}

          {!isMobile && (
            <div style={{ minHeight: 80 }} />
          )}
        </>
      )
    }
    const txtcolor = data ? UtilService.getIColor(data['color_indicator']) : '#1DB859';
    let index, indexValue;
    if (data && data['safety_index'] !== '-' && data['safety_index'] > 1) {
      index = data && data['safety_index'];
      indexValue = data && data['context_indicator'];

      return (
        <div className={classes.rowCol}>
          <div className={clsx(classes.titleSection)} style={{ color: index > 1 ? txtcolor : '#697683' }}>
            {data && <AnalysisScoreIcon color={(index > 1 || index !== '--') ? data['color_indicator'] : 'gray'} type={'safety'} size={0} />}
            <div className={classes.numberTitle}>{index}</div>
            <div className={classes.title}>{indexValue}</div>
          </div>
          {(index && index !== '--' && !isMobile) && <ScoreLinearProgress type={'safety'} variant="determinate" value={Number(index)} barcolor={txtcolor} />}

          <div style={{ minHeight: 80 }}>
            {
              (index && index !== '--') && (
                <p className={classes.zenDescription}>
                  {indexValue && UtilService.getSafetyBlurb(indexValue)}
                </p>
              )
            }
          </div>
        </div>
      )
    }
  };
  const safetyIndustry = () => {
    const data = cliped?.score?.safety || (safetyData ? safetyData : safety_overall);
    if (!data || Object.keys(data).length === 0) return <></>
    if (data && data['safety_index'] !== '-' && data['safety_index'] > 1) {
      const index = data && data['safety_index'];
      return (
        <div style={{ minHeight: 80 }}>
          {
            (index && index !== '--') && (
              <>
                {
                  (sessionOverview.norm_ps && sessionOverview.norm_ps > 0) ?
                    <div className={classes.rowCenter}>
                      <img src={`/assets/icons/overview/briefcase.svg`} alt='bag' style={{ marginRight: 20, marginTop: 8 }} />
                      {getSafetyNormsDiff(index, sessionOverview.norm_ps)}
                    </div>
                    : <Box mt={1}>
                      {!fullLoaded && <Skeleton height={30} width={200} />}
                    </Box>
                }
                {
                  (sessionOverview.overall_safety_index !== null && sessionOverview.overall_safety_index > 0) &&
                  <div className={classes.rowCenter}>
                    <img src={`/assets/icons/overview/non_user.svg`} alt='bag' style={{ marginRight: 25, marginLeft: 5, marginTop: 12 }} />
                    {getSafetyAverageDiff(index, sessionOverview.overall_safety_index)}
                  </div>
                }
                {
                  (sessionOverview.benchmark_safety_average !== null && sessionOverview.benchmark_safety_average > 0) &&
                  <div className={classes.rowCenter}>
                    <img src={`/assets/icons/overview/benchmark_1.svg`} alt='bag' style={{ marginRight: 25, marginLeft: 5, marginTop: 12 }} />
                    {getSafetyBenchmarkDiff(index, sessionOverview.benchmark_safety_average)}
                  </div>
                }
              </>
            )
          }
        </div>
      )
    }
  };

  

  return (
    <div className={classes.root} >
      
      <Grid id={'benchmarkbox'} container direction={'column'} alignContent={'center'} alignItems={'center'} style={{ padding: 15 }}>
      <Grid item xs={8}>

        <Grid container direction={'row'} alignContent={'center'} alignItems={'center'} style={{ padding: 15 }}>
              <Grid item xs={6} className={classes.foo}>
                {getImmersionScore()}
              </Grid>
              <Grid item xs={6} className={classes.foo} style={{ paddingLeft: 0, paddingTop: isMobile ? 30 : 10 }}>
                {getImmersionIndustry()}
              </Grid>
        </Grid>

      </Grid> 
      </Grid> 

      {isSafety && safety_overall?.safety_index && <>
        {(getSafetyScore() || getSafetyIndustry() ) && <Grid container direction={'column'} alignContent={'center'} alignItems={'center'} style={{ padding: 15 }}>
      <Grid item xs={8}>

        <Grid container direction={'row'} alignContent={'center'} alignItems={'center'} style={{ padding: 15 }}>
              <Grid item xs={6} className={classes.foo}>
                {getSafetyScore()}
              </Grid>
              <Grid item xs={6} className={classes.foo} style={{ paddingLeft: 0, paddingTop: isMobile ? 30 : 10 }}>
                {getSafetyIndustry()}
              </Grid>
        </Grid>

      </Grid> 
      </Grid> }
      </>}

      
    </div>
  )
};

export default OverallPerformanceCompare;

const CustomLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 15,
      borderRadius: 5,
      width: 257
    },
    colorPrimary: {
      backgroundColor: "#E4EAF1",
    },
    bar: (props: any) => ({
      borderRadius: 5,
      backgroundColor: props.barcolor
    })
  })
)(LinearProgress);

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 64,
    '@media (max-width: 600px)': {
      paddingTop: 0,
    },
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  titleSection: {
    maxWidth: 500,
    display: 'flex',
    alignItems: 'center'
  },
  foo:{},
  numberTitle: {
    marginTop: 5,
    fontSize: 29,
    minWidth: 60,
    textAlign: 'center',
    fontFamily: 'Spartan-extrabold',
    padding: '0 15px',
    '@media screen and (max-width: 600px)': {
      fontSize: 30
    }
  },
  title: {
    minWidth: 146,
    marginTop: 5,
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      fontSize: 20
    },
    '@media screen and (max-width: 330px)': {
      fontSize: 18
    }
  },
  titleIcon: {
    width: 42,
    height: 42,
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      width: 35,
      height: 35
    },
    '@media screen and (max-width: 330px)': {
      width: 30,
      height: 30
    }
  },
  cardSection: {
    borderRadius: 20,
    background: '#fff',
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
  },
  pdfCardSection: {
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 20px 10px 20px',
    '@media screen and (max-width: 1150px)': {
      padding: '10px 0 5px 10px'
    },
    '@media screen and (max-width: 1023px)': {
      padding: '20px 20px 10px 20px',
    },
    '@media screen and (max-width: 600px)': {
      padding: '10px 10px 5px 10px'
    },
  },
  zenDescription: {
    minHeight: 25,
    fontSize: 14,
    fontFamily: 'roboto-medium',
    color: '#8192A2',
    lineHeight: '19px',
    marginTop: 40,
    '@media screen and (max-width: 600px)': {
      fontSize: 12
    }
  },
  section: {
    flex: 2
  },
  thumbdiv: {
    flex: 1,
    padding: '8px 20px',
    marginRight: 30,
    '@media screen and (max-width: 1150px)': {
      marginRight: 10,
    },
    '@media screen and (max-width: 600px)': {
      padding: 5,
      marginRight: 0,
      display: 'flex',
      alignItems: 'center'
    },
  },
  upDownArrow: {
    width: 13,
    height: 11
  },
  upDownLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 16,
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 3
  },
  normsAverageLabel: {
    fontFamily: 'roboto-bold',
    fontSize: 14,
    color: '#212D40'
  },
  scoreDiv: {
    marginTop: 20
  },
  diffDescription: {
    marginTop: 5
  },
  rowCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  rowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    color: '#697683',
    marginTop: 30,
    lineHeight: 1.5,
    marginBottom: 30
  },
  bagIcon: {
    height: 12,
    position: 'absolute',
    top: 21
  },
  graphBar: {
    width: 1,
    height: 15,
    marginLeft: 6,
    background: '#111',
    position: 'absolute',
  }
}));